import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { ImageComponent, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { CookieNgrxModule } from '@teamfoster/sdk/cookie-ngrx';
import { TextUtilityModule } from '@teamfoster/sdk/text-utility';
import { ButtonModule } from '@teamfoster/sdk/button';


import { YoutubeComponent } from 'src/app/standalone/components/youtube/youtube.component';

@Component({
    selector: 'app-content-block-large-media',
    templateUrl: './content-block-large-media.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './content-block-large-media.component.scss',
    imports: [
        ResizeHtmlImagesPipe,
        CookieNgrxModule,
        TextUtilityModule,
        ButtonModule,
        ImageComponent,
        YoutubeComponent,
    ]
})
export class ContentBlockLargeMediaComponent extends ContentBlockBaseComponent {}
